<div class="details">
  <mat-list *ngIf="moreDetails()">
    <mat-list-item *ngIf="data?.name?.length > 1">
      <span mat-line matListItemTitle>Names</span>
      <span mat-line matListItemLine *ngFor="let name of data.name"
        >{{ name?.firstName }} {{ name?.lastName }}</span
      >
    </mat-list-item>

    <mat-list-item *ngIf="data?.phone?.length > 1">
      <span mat-line matListItemTitle>Phone Numbers</span>
      <span mat-line matListItemLine *ngFor="let phone of data.phone">{{
        phone?.phoneNumber
      }}</span>
    </mat-list-item>

    <mat-list-item *ngIf="data?.email?.length > 1">
      <span mat-line matListItemTitle>Emails</span>
      <span mat-line matListItemLine *ngFor="let email of data.email">{{ email }}</span>
    </mat-list-item>

    <mat-list-item *ngIf="data?.relatives?.length > 1">
      <span mat-line matListItemTitle>Relatives</span>
      <span mat-line matListItemLine *ngFor="let relative of data.relatives"
        >{{ relative?.firstName }} {{ relative?.lastName }}</span
      >
    </mat-list-item>
  </mat-list>
  <div class="no-details-div" *ngIf="!moreDetails()">
    <h1 class="no-details">No Additional Details</h1>
  </div>
</div>
